export const EDIT_COURSE_KNOWLEDGE = "EDIT_COURSE_KNOWLEDGE"
export const EDIT_COURSE_KNOWLEDGE_SUCCESS = "EDIT_COURSE_KNOWLEDGE_SUCCESS"
export const EDIT_COURSE_KNOWLEDGE_CLEAN = "EDIT_USER_CLEAN"
export const EDIT_COURSE_KNOWLEDGE_ERROR = "EDIT_COURSE_KNOWLEDGE_ERROR"
